<eze-modal #modal (onOpen)="onModalOpen()">
	<eze-modal-header>
		<h1>Pay With Card</h1>
	</eze-modal-header>
	<eze-modal-content>
		<eze-alert></eze-alert>

		<h3>Price: {{ price | currency }}</h3>

		<form
			class="smart-form"
			novalidate
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			<div class="row">
				<div class="col-xs-12">
					<eze-input-container label="Full Name">
						<input
							ezeInput
							type="text"
							id="name"
							formControlName="name"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-12">
					<eze-input-container>
						<input
							ezeInput
							type="text"
							id="email"
							formControlName="email"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-12">
					<eze-input-container>
						<select
							ezeInput
							id="country"
							formControlName="country"
							[showValidation]="showValidation"
						>
							<option [value]="null">
								Select...
							</option>
							<option
								*ngFor="let country of stripeCountries"
								[value]="country.code"
							>
								{{ country.country }}
							</option>
						</select>
					</eze-input-container>
				</div>

				<div class="col-xs-12">
					<eze-input-container>
						<input
							ezeInput
							type="text"
							id="address"
							formControlName="address"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-12">
					<eze-input-container>
						<input
							ezeInput
							type="text"
							id="city"
							formControlName="city"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-12" *ngIf="showStateField()">
					<eze-input-container>
						<input
							ezeInput
							type="text"
							id="state"
							formControlName="state"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-12">
					<eze-input-container [label]="zipLabel()">
						<input
							ezeInput
							type="text"
							id="zip"
							formControlName="zip"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>
			</div>

			<section [class.has-error]="!!cardError">
				<label class="help-block">
					Card
					<span>*</span>
				</label>
				<div id="card-element"></div>
				<label class="input">
					<small class="help-block">
						{{ cardError?.message }}
					</small>
				</label>
			</section>

			<button type="subimit" style="display: none;"></button>
		</form>
	</eze-modal-content>
	<eze-modal-footer>
		<eze-button
			(click)="modal.close()"
			context="default"
			style="margin-right: 10px;"
		>
			Cancel
		</eze-button>
		<eze-button (click)="onSubmit()" context="success">
			Submit Payment
		</eze-button>
	</eze-modal-footer>
</eze-modal>
